import './MobileMenu.css';
import Logo from '../../../Images/logo/logo_OlibBlack.svg';
import LoginButton from '../LoginButton';
import { useSelector } from 'react-redux';
// Translate
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MobileMenu = ({ isOpen = false, onClose = () => {} }) => {
  const { t } = useTranslation();

  // Slice
  const { user_email } = useSelector((state) => state.user);
  const { requestLogin } = useSelector((state) => state.institution);

  const isLoggedIn = () => {
    if (requestLogin && user_email.length > 0) {
      return true;
    }

    return false;
  };

  return (
    <div
      className='modal-overlay-mobile-menu'
      style={{
        display: isOpen ? 'flex' : 'none',
      }}
    >
      <div className='modal-mobile-menu'>
        <button className='close-button-mobile-menu' onClick={onClose}>
          ×
        </button>

        <div className='modal-header-mobile-menu'>
          <img
            className='modal-logo-mobile-menu'
            src={Logo}
            alt='Online Library Aquinas'
          />
        </div>

        {!isLoggedIn() && (
          <div className='modal-body-mobile-menu'>
            <p className='modal-text-mobile-menu'>
              {t('Welcome, select the mode you want to use to login.')}
            </p>

            <LoginButton onClose={onClose} />
          </div>
        )}

        <ul className='modal-footer-mobile-menu'>
          <li>
            <Link className='modal-mobile-nav-item' to='/news'>
              {t('Global News')}
            </Link>
          </li>
          <li>
            <Link className='modal-mobile-nav-item' to='/help'>
              {t('FAQs')}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
